var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrionprotocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "#202034"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8769_19186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1164 33.4829C76.1861 33.4829 78.5582 30.9805 78.5582 28.061C78.5582 25.0025 76.0466 22.639 73.1164 22.639C70.0466 22.639 67.6745 25.1415 67.6745 28.061C67.535 30.9805 70.0466 33.4829 73.1164 33.4829Z",
    fill: "url(#paint0_linear_8769_19186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4647 24.3073C41.1624 24.3073 35.86 25.8366 31.3949 28.8951C26.9298 31.8146 23.4414 36.1244 21.488 40.9902C19.3949 45.8561 18.8368 51.278 19.9531 56.561C20.9298 61.8439 23.581 66.5707 27.3484 70.3244C31.1159 74.078 35.9996 76.7195 41.1624 77.6927C46.3252 78.6659 51.9066 78.2488 56.7903 76.1634C61.674 74.078 65.9996 70.6024 68.9298 66.2927C70.6042 63.7902 67.3949 57.3951 68.2321 54.4756C68.7903 52.2512 73.5345 53.5024 73.5345 51.278C73.5345 44.1878 70.7438 37.2366 65.581 32.2317C60.5577 27.2268 53.7205 24.3073 46.4647 24.3073ZM46.4647 66.1537C43.3949 66.1537 40.4647 65.3195 38.0926 63.6512C35.581 61.9829 33.6275 59.6195 32.5112 56.839C31.3949 54.0585 31.1159 51 31.674 48.0805C32.2321 45.161 33.767 42.5195 35.86 40.2951C37.9531 38.0707 40.7438 36.6805 43.674 36.1244C46.6042 35.5683 49.674 35.8463 52.4647 36.9585C55.2554 38.0707 57.6275 40.0171 59.3019 42.5195C60.9763 45.0219 61.8135 47.9415 61.8135 50.861C61.8135 54.8927 60.2786 58.6463 57.3484 61.5658C54.2786 64.4854 50.3717 66.1537 46.4647 66.1537Z",
    fill: "#69F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4649 26.3927C38.3719 26.3927 36.1393 26.6707 34.1859 27.2268C29.0231 29.8683 24.9766 34.039 22.4649 39.0439C19.8138 44.0488 18.9766 49.7488 19.8138 55.3098C23.0231 63.2342 31.1161 68.7951 40.6045 68.7951C46.4649 68.7951 52.1859 66.5707 56.3719 62.539C53.5812 64.9025 49.8138 66.1537 46.1859 66.1537C42.4184 66.0147 38.93 64.6244 36.1393 61.9829C33.4882 59.4805 31.8138 56.0049 31.5347 52.2512C31.2556 48.4976 32.3719 44.8829 34.6045 41.8244C36.837 38.9049 40.1859 36.8195 43.8138 36.1244C47.4417 35.4293 51.3486 36.1244 54.4184 38.0707C57.6277 40.0171 59.9998 43.0756 61.1161 46.5512C62.2324 50.1659 61.9533 53.9195 60.4184 57.3951C62.0928 54.3366 62.93 51 62.93 47.6634C62.651 35.9854 52.744 26.3927 40.4649 26.3927Z",
    fill: "url(#paint1_linear_8769_19186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6516 47.3854C81.3493 46.8293 82.0469 46.1342 82.326 45.161C82.7446 44.3269 82.8841 43.3537 82.7446 42.3805C82.7446 41.4073 82.326 40.5732 81.9074 39.739C81.3493 38.9049 80.6516 38.3488 79.8144 37.7927C79.3958 37.5147 78.8376 37.3756 78.2795 37.2366C77.7214 37.0976 75.9074 36.8195 72.6981 38.3488C70.6051 39.461 69.2097 40.7122 67.8144 42.2415C65.4423 44.7439 63.3493 47.6634 61.5353 50.583C61.3958 50.722 61.2562 50.861 61.2562 51.139C61.1167 51.5561 60.8376 51.9732 60.8376 52.3903C60.2795 56.839 61.8144 60.4537 63.7679 61.0098C66.0004 61.7049 69.3493 58.6464 70.8841 56.0049C71.4423 54.8927 71.7214 53.9195 72.8376 52.5293C73.6748 51.6951 74.3725 51.139 75.7679 50.1659C76.8841 49.3317 78.0004 48.6366 79.2562 47.9415C79.5353 47.8025 79.6748 47.8025 79.9539 47.6634C80.233 47.6634 80.3725 47.5244 80.6516 47.3854Z",
    fill: "url(#paint2_linear_8769_19186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0933 49.4707C74.5119 48.4976 74.6515 47.3854 74.5119 46.4122C74.3724 45.439 73.9538 44.3268 73.2561 43.4927C72.5584 42.6585 71.5817 42.1024 70.6049 41.8244C69.6282 41.5463 68.5119 41.5463 67.3956 41.8244C66.8375 41.9634 65.0236 42.5195 63.0701 45.439C61.8142 47.3854 61.1166 49.1927 60.698 51.139C59.8608 54.4756 59.3026 57.9512 59.1631 61.4268C59.1631 61.5658 59.1631 61.8439 59.1631 61.9829C59.1631 62.4 59.1631 62.8171 59.3026 63.2341C60.1398 65.7366 62.3724 67.4049 64.7445 67.5439C67.8142 67.6829 70.0468 65.0415 70.7445 63.0951C70.884 62.678 71.0235 61.5658 71.1631 59.3415C71.3026 56.839 71.3026 56.4219 71.4422 55.5878C71.7212 53.7805 72.4189 52.1122 73.3956 50.5829C73.5352 50.4439 73.6747 50.1658 73.8142 50.0268C73.8142 49.8878 73.9538 49.6097 74.0933 49.4707Z",
    fill: "url(#paint3_linear_8769_19186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4646 63.5122C70.6042 62.9561 70.7437 62.2609 70.7437 61.5658C70.7437 60.1756 70.1856 58.9244 69.3484 57.8122C68.5112 56.7 67.2553 56.0048 65.9995 55.7268C64.6042 55.4488 63.2088 55.5878 62.0925 56.1439C60.8367 56.7 59.86 57.6731 59.3019 58.9244C58.3251 60.4536 57.0693 61.8439 55.6739 62.817C55.5344 62.9561 55.5344 62.9561 55.3949 63.0951C53.1623 65.3195 50.7902 66.2927 48.8367 66.9878C45.3484 68.378 32.9298 69.4902 25.8135 63.2341C23.0228 60.4536 19.8135 55.0317 19.8135 55.0317C20.7902 61.4268 23.9995 67.2658 28.8832 71.5756C33.767 75.7463 40.046 78.1097 46.6042 78.1097C50.6507 78.1097 54.6972 76.8585 54.6972 76.8585C59.7205 75.3292 64.3251 72.2707 67.6739 68.1C68.5112 67.1268 69.2088 66.1536 69.767 65.0414C70.046 64.7634 70.3251 64.2073 70.4646 63.5122Z",
    fill: "url(#paint4_linear_8769_19186)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8769_19186",
    x1: 73.6109,
    y1: 22.5826,
    x2: 72.7972,
    y2: 30.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE37AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE079C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8769_19186",
    x1: 61.0114,
    y1: 38.4628,
    x2: 20.7462,
    y2: 56.8041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE37AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8769_19186",
    x1: 81.5838,
    y1: 36.1678,
    x2: 63.8294,
    y2: 57.7063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A047EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8769_19186",
    x1: 68.7242,
    y1: 42.0047,
    x2: 65.491,
    y2: 61.3202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE37AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE079C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8769_19186",
    x1: 69.4536,
    y1: 56.0003,
    x2: 33.1936,
    y2: 67.5092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE079C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8769_19186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 57,
    fill: "white",
    transform: "translate(18 22.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrionprotocol);
export default __webpack_public_path__ + "static/media/orionprotocol.a3bf1934f5f92bd0e895cdf097cd080e.svg";
export { ForwardRef as ReactComponent };